import React from "react";
import { Resource } from "react-admin";
import UserIcon from "@material-ui/icons/AccountBox";

import List from "./List";
export default permissions => (
    <Resource name="profile" icon={UserIcon} list={List} />
);



// WEBPACK FOOTER //
// ./src/resources/Profile/index.js